module.exports = __webpack_public_path__ + "static/media/mbari_badge.d74b5a20.png";